"use client"

import { Skeleton } from "@mui/material";
import useOnLoadEvent from "@v2/hooks/useOnLoadEvent";
import { useState } from "react";
export default function Enemad() {

    const [loaded, setLoaded] = useState(false)

    useOnLoadEvent(() => {
        setLoaded(true)
    })

    return loaded ? (
        <a referrerPolicy='origin' aria-label='نماد اعتماد الکترونیک عینک وحدت'
            target='_blank'
            href='https://trustseal.enamad.ir/?id=540261&Code=8FsttFZSSMImYYaHOmNJWoHffILwjVMC'>
            <img
                onError={(e: any) => e.target.src = "/assets/enamad_fallback.webp"}
                referrerPolicy='origin'
                src='https://trustseal.enamad.ir/logo.aspx?id=540261&Code=8FsttFZSSMImYYaHOmNJWoHffILwjVMC'
                alt='نماد تجارت الکترونیکی'
                // "code" is not a known img prop, so it goes through a spread
                {...{ code: '8FsttFZSSMImYYaHOmNJWoHffILwjVMC' }}
                style={{
                    cursor: "pointer",
                    width: "75px",
                    height: "82px"
                }}
            />
        </a>
    ) : <Skeleton height={86} width={75} variant="rounded" />
}
